export default __webpack_public_path__ + "static/media/Darknetdemo.d1053f36.m4v";